import { useMutation } from 'react-query';
import { useAPI } from 'services/axios';
import useToast from 'services/responseToast';

const CreateChat = (payload: any) => {
  const method = 'POST';
  const url = '/chats';
  return useAPI({
    method,
    url,
    data: payload,
  });
};

export const useCreateChatQuery = () => {
  const responseToast = useToast();
  return useMutation(CreateChat, {
    onSuccess: () => responseToast.toastSuccess('Chat created successfully'),
    onError: (error: any) =>
      responseToast.toastError(error, 'something went wrong'),
  });
};

const GetChatAll = () => {
  const method = 'GET';
  const url = '/chats/all';
  return useAPI({
    method,
    url,
  });
};

export const useGetChatAllQuery = () => {
  const responseToast = useToast();
  return useMutation(GetChatAll, {
    onSuccess: () => {},
    onError: (error: any) =>
      responseToast.toastError(error, 'something went wrong'),
  });
};

const GetChatById = (id: any) => {
  const method = 'GET';
  const url = `/chats/${id}`;
  return useAPI({
    method,
    url,
  });
};

export const useGetChatByIdQuery = () => {
  const responseToast = useToast();
  return useMutation(GetChatById, {
    onSuccess: () => responseToast.toastSuccess('Chat fetch successfully'),
    onError: (error: any) =>
      responseToast.toastError(error, 'something went wrong'),
  });
};

const GetChatThreadsById = (id: any) => {
  const method = 'GET';
  const url = `/chats/${id}/threads`;
  return useAPI({
    method,
    url,
  });
};

export const useGetChatThreadsByIdQuery = () => {
  const responseToast = useToast();
  return useMutation(GetChatThreadsById, {
    onSuccess: () => responseToast.toastSuccess('Chat fetch successfully'),
    onError: (error: any) =>
      responseToast.toastError(error, 'something went wrong'),
  });
};

const DeleteChatById = (id: any) => {
  const method = 'DELETE';
  const url = `/chats/${id}`;
  return useAPI({
    method,
    url,
  });
};

export const useDeleteChatByIdQuery = () => {
  const responseToast = useToast();
  return useMutation(DeleteChatById, {
    onSuccess: () => responseToast.toastSuccess('Chat deleted successfully'),
    onError: (error: any) =>
      responseToast.toastError(error, 'something went wrong'),
  });
};

const UpdateChatById = (id: any) => {
  const method = 'PUT';
  const url = `/chats/${id}`;
  return useAPI({
    method,
    url,
  });
};

export const useUpdateChatByIdQuery = () => {
  const responseToast = useToast();
  return useMutation(UpdateChatById, {
    onSuccess: () => responseToast.toastSuccess('Chat deleted successfully'),
    onError: (error: any) =>
      responseToast.toastError(error, 'something went wrong'),
  });
};
